import {createReducer} from '@reduxjs/toolkit';

import {QUOTA_TYPE_KEYS} from '@explorer/constants';
import {
  consumeTileQuota,
  fetchSubscriptions,
  setCurrentSubscriptions,
} from '@explorer/actions/subscriptions';
import {setTileMode} from '@explorer/actions/tiles';

export const initialState = {
  ids: [],
  byId: {},
  loading: false,
  error: null,
  current: [],
};

const subscriptions = createReducer(initialState, builder => {
  builder.addCase(fetchSubscriptions.pending, state => {
    state.loading = true;
  });

  builder.addCase(fetchSubscriptions.fulfilled, (state, {payload}) => {
    const subs = {};
    const quotaTypes = Object.values(QUOTA_TYPE_KEYS);

    payload.forEach(sub => {
      quotaTypes.forEach(type => {
        if (sub[type]) {
          sub[type] = {
            ...sub[type],
            remains: sub[type].limit - sub[type].current,
          };
        }
      });
      subs[sub.id] = sub;
    });

    state.byId = subs;
    state.ids = payload.map(s => s.id);
    state.loading = false;
  });

  builder.addCase(fetchSubscriptions.rejected, (state, {error}) => {
    state.loading = false;
    state.error = error.message ? error.message : error;
  });

  builder.addCase(consumeTileQuota, (state, {payload}) => {
    const {type, subId, count} = payload;
    const quotaTypeKey = QUOTA_TYPE_KEYS[type];

    const subIds = Array.isArray(subId) ? subId : [subId];

    subIds.forEach(id => {
      const quota = state.byId[id] && state.byId[id][quotaTypeKey];

      if (quota) {
        state.byId[id][quotaTypeKey].remains = quota.remains - (count || 1);
      }
    });
  });

  builder.addCase(setCurrentSubscriptions, (state, {payload}) => {
    state.current = payload;
  });

  builder.addCase(setTileMode, state => {
    state.current = [];
  });
});

export default subscriptions;
